import * as React from "react";
import { useState } from "react";
import { config } from "../../../../config/domain";
import Checkbox from "../../../generic/checkbox";
import EdModal from "../../../generic/edModal";
import InputField from "../../../generic/inputField";
import TocDropdown from "../../../generic/tocDropdown";
import { getArea, getFullAddress } from "../../../service/generic/otherApi";
import { IListObj } from "../../../types/genericTypes";
import { getOCRResp } from "../../generic/qCCheck";
import {
  alphaNumExp,
  alphaNumExpWithSpaceForAddr,
  betweenNChars,
  detectIntWithSpace,
  integerExp,
  specialCharExpressionForAddr,
} from "../../../utils/regex";
import { FileUploadSection } from "../../generic/fileUploadSection";
import { getMergeDocumentBase64 } from "../../../service/serviceRequest/srApiService";
const addressProofOptions: Array<IListObj> = [
  { value: "DrivingLicense", display: "Driving License" },
  { value: "NREGAJobCard", display: "NREGA job card" },
  { value: "Passport", display: "Passport" },
  { value: "VotersId", display: "Voters Id" },
];
var addressType = [
  {
    value:1,
    TotLines: 3,
    size: 30
  },
  {
    value:2,
    TotLines: 4,
    size: 36
  },
  {
    value:3,
    TotLines: 3,
    size: 50
  }
]
export const addressFormErrorObj = {
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  addressLine4: "",
  pincode: "",
  area: "",
  proof: "",
  fileName: "",
  fileData: "",
};
export const AddressModificationForm = (props: any) => {
  const errorString = "Area not exist.";
  const [errors, setErrors] = React.useState<any>({ ...addressFormErrorObj });
  const [areaOptions, setAreaOptions] = useState<any>([]);
  const [pincodeEnabled, setPincodeEnabled] = useState<boolean>(false);
  const [dropDownlownValue, setDropDownValueChanged] = useState<boolean>(false);
  const [showPincodeErrorModel, setShowPincodeErrorModel] = useState(false);
  const [frontBack, setFrontBack] = useState<boolean>(false);
  const [frontDocument, setFrontDocument] = useState<any>({});
  const [backDocument, setBackDocument] = useState<any>({});

  React.useEffect(() => {
    if (showPincodeErrorModel) {
      (
        document.getElementsByClassName("modal-Sr")[0] as HTMLDivElement
      ).scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [showPincodeErrorModel]);
  React.useEffect(() => {
    let err = errors;
    let addressObj = props.addressObj;

    Object.keys(props.addressObj).map((k: any, i: any) => {
      if (k.includes("addressLine")) {
        if (addressObj[k]) {
          if (addressObj[k] && addressObj[k].length > addressType[props.addessType-1].size) {
            err[k] =
              "Address Line " + (i + 1) + " maximum length is "+addressType[props.addessType-1].size+" characters";
            addressObj[k] = undefined;
          } else if (
            !alphaNumExpWithSpaceForAddr.test(
              addressObj[k].replace(/\//g, "")
            ) &&
            !specialCharExpressionForAddr(0, 0).test(addressObj[k])
          ) {
            err[k] =
              "Special characters are not allowed like ~ ` # $ % ^ & * ( ) = + { } [ ] \\ | : ; ” ’ < > , ? _";
            addressObj[k] = addressObj[k];
          }
        }
      }
    });

    setErrors(err);
    props.setAddressObj({
      ...props.addressObj,
      addressObj,
      ["proof"]: addressProofOptions[0].value,
    });

    if (props.addressObj.pincode && props.addressObj.pincode.length === 6) {
      setAreaOptions(props.areas && props.areas.length > 0 ? props.areas : []);
      if (props.areas && props.areas.length === 1) {
        props.addressObj.area = props.areas[0].value;
      }
      if (props.areas && props.areas.length > 1) {
        if (props.sameAsPermanent) props.addressObj.area = props.areas[0].value;
        else getAreaDetails(props.addressObj.pincode);
      }
      if (props.areas && props.areas.length === 0)
        getAreaDetails(props.addressObj.pincode);
    }
  }, []);
  const toCamelCase = (string: any) => {
    return string.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  const isEmptyObject = (obj: any) => {
    if (JSON.stringify(obj) !== "{}") return true;
    return false;
  };
  const isKraDetails = () => {
    if (
      !props.childSr &&
      isEmptyObject(props.kraDetails.webSign) &&
      isEmptyObject(props.kraDetails.panCard) &&
      isEmptyObject(props.kraDetails.photo)
    ) {
      return true;
    } else {
      if (props.childSr) {
        return true;
      } else {
        return false;
      }
    }
  };
  const isSecondFileDetails = (addressObj: any) => {
    if (
      addressObj &&
      frontBack &&
      !addressObj.fileName2 &&
      !addressObj.fileData2
    ) {
      return false;
    } else {
      return true;
    }
  };

  const isValid = () => {
    let validations = Object.values(errors).map((val: any) => {
      if (val) return false;
      else return true;
    });

    // let isValid = Object.values(props.addressObj).map((val: any))
    let hasFormErr: any = false;
    //console.log('props.addressObj test',props.addressObj,props.secondAddress);

    Object.keys(props.addressObj).map((k: any, i: any) => {
      if (k.includes("addressLine")) {
        if (props.addressObj[k]) {
          if (handleChangeAddressErrors(k, props.addressObj[k], "yes"))
            hasFormErr = true;
        }
        // if(props.addressObj[k]===undefined) hasFormErr= true;
        // //console.log('hasFormErr',hasFormErr,'props.addressObj[k]',props.addressObj[k]);
      }
    });
    Object.keys(props.secondAddress).map((k: any, i: any) => {
      if (k.includes("addressLine")) {
        if (props.secondAddress[k]) {
          //console.log('props.secondAddress[k]',props.secondAddress[k]);
          if (handleChangeAddressErrors(k, props.secondAddress[k], "yes"))
            hasFormErr = true;
        }

        // //console.log('hasFormErr',hasFormErr,'props.addressObj[k]',props.addressObj[k]);
      }
    });
    // console.log("validations", validations, hasFormErr);

    return validations.every((x) => x === true) && !hasFormErr;
  };
  React.useEffect(() => {
    if (props.addressObj) {
      if (
        props.addressObj.addressLine1 &&
        isValid() &&
        isKraDetails() &&
        props.addressObj.pincode &&
        props.addressObj.area &&
        props.addressObj.proof
      ) {
        if (props.childSr) {
          if (!props.addressObj.fileName && !props.addressObj.fileData) {
            props.disabledButton(true);
          }
        } else {
          if (
            props.addressObj.fileName &&
            props.addressObj.fileData &&
            isSecondFileDetails(props.secondAddress)
          ) {
            props.disabledButton(true);
          } else {
            props.disabledButton(false);
          }
        }

        if (props.sameAsPermanent) {
          if (props.childSr) {
            if (!props.addressObj.fileName && !props.addressObj.fileData) {
              props.disabledButton(true);
            }
          } else {
            if (props.addressObj.fileName && props.addressObj.fileData) {
              props.disabledButton(true);
            } else {
              props.disabledButton(false);
            }
          }
        } else {
          if (
            props.secondAddress &&
            props.secondAddress.addressLine1 &&
            isValid() &&
            isKraDetails() &&
            props.secondAddress.pincode &&
            props.secondAddress.area &&
            props.secondAddress.proof
          ) {
            if (props.childSr) {
              if (
                !props.secondAddress.fileName &&
                !props.secondAddress.fileData
              ) {
                props.disabledButton(true);
              }
            } else {
              if (
                props.secondAddress.fileName &&
                props.secondAddress.fileData &&
                isSecondFileDetails(props.secondAddress)
              ) {
                if (
                  !props.addressObj.fileName &&
                  !props.addressObj.fileData &&
                  !isSecondFileDetails(props.addressObj)
                ) {
                  props.disabledButton(false);
                } else {
                  props.disabledButton(true);
                }
              } else {
                props.disabledButton(false);
              }
            }
          } else {
            props.disabledButton(false);
          }
        }
      } else {
        props.disabledButton(false);
      }
    }
  }, [props.addressObj, props.kraDetails]);
  React.useEffect(() => {
    if (props.sameAsPermanent && props.addressObj) {
      if (
        props.addressObj.addressLine1 &&
        isValid() &&
        isKraDetails() &&
        props.addressObj.pincode &&
        props.addressObj.area &&
        props.addressObj.proof
      ) {
        if (props.childSr) {
          if (!props.addressObj.fileName && !props.addressObj.fileData) {
            props.disabledButton(true);
          }
        } else {
          if (props.addressObj.fileName && props.addressObj.fileData) {
            props.disabledButton(true);
          } else {
            props.disabledButton(false);
          }
        }
      } else {
        props.disabledButton(false);
      }
    } else {
      if (
        props.addressObj.addressLine1 &&
        isValid() &&
        isKraDetails() &&
        props.addressObj.pincode &&
        props.addressObj.area &&
        props.addressObj.proof &&
        props.addressObj.fileName &&
        props.addressObj.fileData
      ) {
        if (
          props.secondAddress &&
          props.secondAddress.addressLine1 &&
          isValid() &&
          isKraDetails() &&
          props.secondAddress.pincode &&
          props.secondAddress.area &&
          props.secondAddress.proof
        ) {
          if (props.childSr) {
            if (
              !props.secondAddress.fileName &&
              !props.secondAddress.fileData
            ) {
              props.disabledButton(true);
            }
          } else {
            if (props.secondAddress.fileName && props.secondAddress.fileData) {
              props.disabledButton(true);
            } else {
              props.disabledButton(false);
            }
          }
        } else {
          props.disabledButton(false);
        }
      } else {
        props.disabledButton(false);
      }
    }
  }, [props.sameAsPermanent]);
  React.useEffect(() => {
    if (!(frontDocument && frontDocument.fileName && frontDocument.fileData)) {
      props.disabledButton(false);
      props.setAddressObj({
        ...props.addressObj,
        ["fileName"]: undefined,
        ["fileData"]: undefined,
      });
    }
  }, [frontDocument]);
  React.useEffect(() => {
    if (backDocument && backDocument.fileName && backDocument.fileData) {
      //  mergeDocuments();
      if (
        props.sameAsPermanent &&
        !(
          props.addressObj.addressLine1 &&
          isValid() &&
          isKraDetails() &&
          props.addressObj.pincode &&
          props.addressObj.area &&
          props.addressObj.proof &&
          props.addressObj.fileName &&
          props.addressObj.fileData
        )
      ) {
        props.setAddressObj({
          ...props.addressObj,
          ["fileName2"]: backDocument.fileName,
          ["fileData2"]: backDocument.fileData,
          ["imgSrc2"]: backDocument.imgSrc,
        });
        props.disabledButton(false);
      } else if (!props.sameAsPermanent) {
        if (
          !(
            props.addressObj.addressLine1 &&
            isValid() &&
            isKraDetails() &&
            props.addressObj.pincode &&
            props.addressObj.area &&
            props.addressObj.proof &&
            props.addressObj.fileName &&
            props.addressObj.fileData
          )
        ) {
          props.disabledButton(false);
        } else {
          if (
            !(
              props.secondAddress &&
              props.secondAddress.addressLine1 &&
              isValid() &&
              isKraDetails() &&
              props.secondAddress.pincode &&
              props.secondAddress.area &&
              props.secondAddress.proof &&
              props.secondAddress.fileName &&
              props.secondAddress.fileData
            )
          ) {
            if (
              frontBack &&
              props.addressObj.fileName &&
              props.addressObj.fileData
            ) {
              props.setAddressObj({
                ...props.addressObj,
                ["fileName2"]: backDocument.fileName,
                ["fileData2"]: backDocument.fileData,
                ["imgSrc2"]: backDocument.imgSrc,
              });
            }
            props.disabledButton(false);
          } else {
            props.setAddressObj({
              ...props.addressObj,
              ["fileName2"]: backDocument.fileName,
              ["fileData2"]: backDocument.fileData,
              ["imgSrc2"]: backDocument.imgSrc,
            });
            props.disabledButton(true);
          }
        }
      } else {
        props.setAddressObj({
          ...props.addressObj,
          ["fileName2"]: backDocument.fileName,
          ["fileData2"]: backDocument.fileData,
          ["imgSrc2"]: backDocument.imgSrc,
        });
        props.disabledButton(true);
      }
    }
  }, [backDocument]);

  // React.useEffect(() => {
  //   if (props.childSr) {
  //     if (props.addressObj && props.addressObj.addressLine1 &&
  //       props.addressObj.addressLine2 &&
  //       props.addressObj.pincode &&
  //       props.addressObj.area) {
  //       props.disabledButton(true);
  //     } else {
  //       props.disabledButton(false);
  //     }
  //   }
  // }, [props.childSr]);
  React.useEffect(() => {
    if (frontBack) {
      setFrontDocument({
        ["fileName"]: props.addressObj.fileName,
        ["fileData"]: props.addressObj.fileData,
        ["imgSrc"]: props.addressObj.imgSrc,
      });
      props.disabledButton(false);
    } else {
      if (
        props.addressObj.addressLine1 &&
        isValid() &&
        isKraDetails() &&
        props.addressObj.pincode &&
        props.addressObj.area &&
        props.addressObj.proof &&
        props.addressObj.fileName &&
        props.addressObj.fileData
      ) {
        if (
          props.secondAddress &&
          props.secondAddress.addressLine1 &&
          isValid() &&
          isKraDetails() &&
          props.secondAddress.pincode &&
          props.secondAddress.area &&
          props.secondAddress.proof
        ) {
          if (props.childSr) {
            if (
              !props.secondAddress.fileName &&
              !props.secondAddress.fileData
            ) {
              props.disabledButton(true);
            }
          } else {
            if (props.secondAddress.fileName && props.secondAddress.fileData) {
              props.disabledButton(true);
            } else {
              props.disabledButton(false);
            }
          }
        } else {
          props.disabledButton(false);
        }
      } else {
        props.disabledButton(false);
      }
    }
  }, [frontBack]);
  // React.useEffect(() => {
  //   if (isKraDetails()) {
  //     props.disabledButton(true);
  //   } else {
  //     props.disabledButton(false);
  //   }
  // }, [props.kraDetails]);
  async function getAreaDetails(pincode: any) {
    if (pincode && pincode.length === 6) {
      try {
        let areaResp = await getArea(pincode);
        if (areaResp) {
          let areas = areaResp.data.areas;
          if (areas) {
            const list = areas.map((respObj: any) => {
              return {
                value: toCamelCase(respObj.toLowerCase()),
                display: toCamelCase(respObj.toLowerCase()),
              };
            });
            if (
              list &&
              list.length === 1 &&
              toCamelCase(list[0].value.toLowerCase()) ===
                toCamelCase(errorString.toLowerCase())
            ) {
              setErrors({ ...errors, ["pincode"]: "Pincode is not valid" });
              setShowPincodeErrorModel(true);
              setAreaOptions([]);
              props.setAddressObj({
                ...props.addressObj,
                ["pincode"]: undefined,
              });
              setPincodeEnabled(true);
            } else {
              setErrors({ ...errors, ["pincode"]: "" });
              setAreaOptions(list);
              props.setAddressObj({
                ...props.addressObj,
                ["pincode"]: pincode,
                ["area"]: list[0].value,
              });
              getFullAddressDetails(pincode, list[0].value);
              setPincodeEnabled(false);
            }
          }
        }
      } catch (e) {
        openSRErrorPopup();
      }
    }
  }
  async function getFullAddressDetails(pincode: any, area: any) {
    try {
      if (pincode && pincode.length === 6 && area) {
        let payloadObj = { area: area, pinCode: pincode };
        let fullAddress = await getFullAddress(payloadObj);
        if (fullAddress && fullAddress.data) {
          props.setAddressObj({
            ...props.addressObj,
            ["pincode"]: pincode,
            ["area"]: toCamelCase(area),
            ["stateStr"]: toCamelCase(fullAddress.data.state.toLowerCase()),
            ["city"]: toCamelCase(fullAddress.data.city.toLowerCase()),
          });
        }
      } else {
        props.setAddressObj({
          ...props.addressObj,
          ["area"]: area,
          ["stateStr"]: "",
          ["city"]: "",
        });
      }
    } catch (error) {
      openSRErrorPopup();
    }
  }
  const openSRErrorPopup = () => {
    // props.setLoader(false);
    if (props.onSubmit)
      props.onSubmit("addressModification", {
        headerText:
          "There was some problem in raising service request. Please try again later.",
      });
  };

  function getDocumentCategory(proof: any, documentCategory: any) {
    if (proof === "Aadhar card") {
      documentCategory.name = "Aadhar";
      documentCategory.id = 117;
    } else if (proof === "Voters Id") {
      documentCategory.name = "Voters Id";
      documentCategory.id = 116;
    } else if (proof === "Passport") {
      documentCategory.name = "Passport";
      documentCategory.id = 114;
    } else if (proof === "Driving License") {
      documentCategory.name = "Driving License";
      documentCategory.id = 118;
    }
    return documentCategory;
  }
  const handleSubmitForPermantAddressFile = (fileDetails: any) => {
    setDropDownValueChanged(false);
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      if (!frontBack) {
        if (props.accountCode && props.addressObj.proof !== "NREGA job card") {
          let documentCategory = { name: "", id: 0 };
          documentCategory = getDocumentCategory(
            props.addressObj.proof,
            documentCategory
          );
          let requestPayload = {
            applicationid: props.accountCode,
            base64document: fileDetails.base64Data.split(",")[1],
            documentcategory: documentCategory.name,
            documentid: documentCategory.id,
            source: "DIY",
          };
          let ocrResp: any;
          ocrResp = getOCRResp(documentCategory.name, requestPayload);
          if (
            ocrResp.status === "completed" &&
            ocrResp.result.extraction_output
          ) {
            //  //console.log(ocrResp);
          }
        }
        let imgSrc = "";
        if (fileDetails.docFile.split(".")[1].toLowerCase() !== "pdf") {
          imgSrc = fileDetails.base64Data;
        }
        // //console.log(imgSrc);
        props.setAddressObj({
          ...props.addressObj,
          ["fileName"]: fileDetails.docFile,
          ["fileData"]: fileDetails.base64Data.split(",")[1],
          ["imgSrc"]: imgSrc,
        });
      } else {
        let imgSrc = "";
        if (fileDetails.docFile.split(".")[1].toLowerCase() !== "pdf") {
          imgSrc = fileDetails.base64Data;
        }
        setFrontDocument({
          ["fileName"]: fileDetails.docFile,
          ["fileData"]: fileDetails.base64Data.split(",")[1],
          ["imgSrc"]: imgSrc,
        });
        props.setAddressObj({
          ...props.addressObj,
          ["fileName"]: fileDetails.docFile,
          ["fileData"]: fileDetails.base64Data.split(",")[1],
          ["imgSrc"]: imgSrc,
        });
      }
    } else {
      if (!frontBack) {
        props.setAddressObj({
          ...props.addressObj,
          ["fileName"]: undefined,
          ["fileData"]: undefined,
        });
      } else {
        setFrontDocument({
          ["fileName"]: undefined,
          ["fileData"]: undefined,
        });
        props.setAddressObj({
          ...props.addressObj,
          ["fileName"]: undefined,
          ["fileData"]: undefined,
        });
      }
    }
  };
  const handleSubmitForBackDocument = (fileDetails: any) => {
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      let imgSrc = "";
      if (fileDetails.docFile.split(".")[1].toLowerCase() !== "pdf") {
        imgSrc = fileDetails.base64Data;
      }
      setBackDocument({
        ["fileName"]: fileDetails.docFile,
        ["fileData"]: fileDetails.base64Data.split(",")[1],
        ["imgSrc"]: imgSrc,
      });
    } else {
      setFrontBack(false);
      setBackDocument({
        ["fileName"]: undefined,
        ["fileData"]: undefined,
      });
    }
  };
  function handleChangeAddressErrors(key: any, value: any, validate?: any) {
    let hasErr = false;
    if (key.includes("addressLine")) {
      let index = key.replace("addressLine", "");
      if(key === "addressLine1" && value.length < 1){
        setErrors({ ...errors, [key]: "Please enter Address in Line 1" });
      } else if (value && value.length > addressType[props.addessType-1].size) {
        if (!validate) {
          props.setAddressObj({ ...props.addressObj, [key]: value });
          setErrors({
            ...errors,
            [key]: "Address Line " + index + " maximum length is "+addressType[props.addessType-1].size+" characters",
          });
        }

        hasErr = true;
      } else if (detectIntWithSpace.test(value)) {
        if (!validate) {
          props.setAddressObj({ ...props.addressObj, [key]: value });
          setErrors({
            ...errors,
            [key]: "Line " + index + " is not allowed numbers only.",
          });
        }

        hasErr = true;
      } else if (
        !alphaNumExpWithSpaceForAddr.test(value.replace(/\//g, "")) &&
        !specialCharExpressionForAddr(0, 0).test(value)
      ) {
        if (!validate) {
          setErrors({
            ...errors,
            [key]:
              "Special characters are not allowed like ~ ` # $ % ^ & * ( ) = + { } [ ] \\ | : ; ” ’ < > , ? _",
          });
          props.setAddressObj({ ...props.addressObj, [key]: value });
        }

        hasErr = true;
      } else if (!specialCharExpressionForAddr(0, 0).test(value)) {
        if (!validate) {
          setErrors({
            ...errors,
            [key]:
              "Special characters are not allowed like ~ ` # $ % ^ & * ( ) = + { } [ ] \\ | : ; ” ’ < > , ? _",
          });
          props.setAddressObj({ ...props.addressObj, [key]: value });
        }

        hasErr = true;
      } else {
        //console.log('errors',errors);
        if (!validate) {
          setErrors({ ...errors, [key]: "" });
          props.setAddressObj({ ...props.addressObj, [key]: value });
        }
      }
    } else if (key === "pincode") {
      if (!value) {
        if (!validate) {
          setAreaOptions([]);
          setErrors({ ...errors, [key]: undefined });
          props.setAddressObj({ ...props.addressObj, [key]: undefined });
        }
      } else if (value && value.length < 6 && !integerExp.test(value)) {
        setAreaOptions([]);
        setErrors({ ...errors, [key]: "Pincode is not valid" });
        // setShowPincodeErrorModel(true);
        props.setAddressObj({ ...props.addressObj, [key]: undefined });
        setPincodeEnabled(true);
        hasErr = true;
      } else if (value && value.length > 6 && !integerExp.test(value)) {
        setAreaOptions([]);
        setErrors({ ...errors, [key]: "Pincode is not valid" });
        setShowPincodeErrorModel(true);
        props.setAddressObj({ ...props.addressObj, [key]: undefined });
        setPincodeEnabled(true);
        hasErr = true;
      } else if (
        !alphaNumExpWithSpaceForAddr.test(value.replace(/\//g, "")) &&
        !specialCharExpressionForAddr(0, 0).test(value)
      ) {
        setAreaOptions([]);
        setErrors({ ...errors, [key]: "Pincode is not valid" });
        setShowPincodeErrorModel(true);
        props.setAddressObj({ ...props.addressObj, [key]: undefined });
        setPincodeEnabled(true);
        hasErr = true;
      } else if (value && !integerExp.test(value)) {
        setAreaOptions([]);
        setErrors({ ...errors, [key]: "Pincode is not valid" });
        setShowPincodeErrorModel(true);
        props.setAddressObj({ ...props.addressObj, [key]: undefined });
        setPincodeEnabled(true);
        hasErr = true;
      } else if (value && value.length === 6 && !integerExp.test(value)) {
        setAreaOptions([]);
        getAreaDetails(value);
      }
    }
    //console.log('hasErr',hasErr);

    if (validate) return hasErr;
  }
  function handleChangeAddress(key: any, value: any) {
    if (key.includes("addressLine")) {
      setErrors({ ...errors, [key]: "" });
      props.setAddressObj({ ...props.addressObj, [key]: value });
    } else if (key === "pincode") {
      if (value.length <= 6) {
        setAreaOptions([]);
        setErrors({ ...errors, [key]: "Pincode is not valid" });
        props.setAddressObj({ ...props.addressObj, [key]: undefined });
      }
      if (value.length === 6) {
        setAreaOptions([]);
        getAreaDetails(value);
      }
    } else if (key === "area") {
      getFullAddressDetails(props.addressObj.pincode, value);
    } else if (key === "proof") {
      //props.setAddressObj({ ...props.addressObj, [key]: value });
      setDropDownValueChanged(true);
      if (props.addressObj.fileName && props.addressObj.fileData) {
        setFrontDocument(undefined);
        props.setAddressObj({
          ...props.addressObj,
          [key]: value,
          ["fileName"]: undefined,
          ["fileData"]: undefined,
        });
        if (backDocument && backDocument.fileName && backDocument.fileData) {
          setBackDocument(undefined);
        }
      } else {
        props.setAddressObj({
          ...props.addressObj,
          [key]: value,
          ["fileName"]: undefined,
          ["fileData"]: undefined,
        });
      }
      // props.setAddressObj({
      //   ...props.addressObj,
      //   ["fileName"]: undefined,
      //   ["fileData"]: undefined,
      // });
    }
  }

  function wrongPinCodeMessagePOPUp(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal innerModal--inputs">
        <div className="modal-content">
          <div className="modal-body scrollableModal" id="custom_scrollBar">
            <div className="finalScreen consentPopup pinError">
              <div className="inProgress_wrap">
                <div className=" icon-wrap icon_wrap_red">
                  <i className="edel-icon-exclamation"></i>
                </div>
              </div>
              <div>
                <p className="field-head text-center">
                  This Pincode is not identifiable
                </p>
              </div>
              <div>
                <p className="field-subHead desc text-center subTextHead">
                  Please contact your RM or write to us at
                </p>
                <p className="text-center">
                  <a href="mailto:helpdesk@nuvama.com" className="mail_link">
                    helpdesk@nuvama.com
                  </a>
                </p>
              </div>
              <div className="display-flex btn_links">
                <div>
                  <button
                    className="ed_button button submit_btn "
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPincodeErrorModel(false);
                    }}
                  >
                    Search Another
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div>
        <div className="custom--row incomeMsg--row">
          <div className=" form-field custom-col">
            <label className="input-label">Address Line 1</label>
            <div className="italic-placeholder">
              <InputField
                type="text"
                defaultValue={props.addressObj?.addressLine1}
                maxLength={addressType[props.addessType-1].size}
                onChange={(value) => {
                  //      //console.log(value.length);
                  //    //console.log(!specialCharExpressionForAddr(5, 30).test(value));
                  handleChangeAddress("addressLine1", value);
                }}
                onBlur={() => {}}
                onMouseOut={(val) => {
                  handleChangeAddressErrors("addressLine1", val);
                }}
                placeholder={"House/flat no., Road"}
                errorText={errors.addressLine1}
                helpTextColor="blue"
                helpText={
                  props.addressObj &&
                  props.addressObj.addressLine1 &&
                  props.addressObj.addressLine1.length === addressType[props.addessType-1].size
                    ? "You can enter maximum of "+ addressType[props.addessType-1].size +" characters in this line."
                    : ""
                }
              />
            </div>
          </div>

          <div className=" form-field custom-col">
            <label className="input-label">Address Line 2</label>
            <div className="italic-placeholder">
              <InputField
                defaultValue={props.addressObj?.addressLine2}
                maxLength={addressType[props.addessType-1].size}
                type="text"
                onChange={(value) => {
                  handleChangeAddress("addressLine2", value);
                }}
                onBlur={() => {}}
                onMouseOut={(val) => {
                  handleChangeAddressErrors("addressLine2", val);
                }}
                placeholder="Locality, Landmark"
                errorText={errors.addressLine2}
                helpTextColor="blue"
                helpText={
                  props.addressObj &&
                  props.addressObj.addressLine2 &&
                  props.addressObj.addressLine2.length === addressType[props.addessType-1].size
                    ? "You can enter maximum of "+ addressType[props.addessType-1].size +" characters in this line."
                    : ""
                }
              />
            </div>
          </div>
        </div>
        <div className="custom--row incomeMsg--row">
          <div className=" form-field custom-col">
            <label className="input-label">Address Line 3</label>
            <div className="italic-placeholder">
              <InputField
                type="text"
                defaultValue={props.addressObj?.addressLine3}
                maxLength={addressType[props.addessType-1].size}
                onChange={(value) => {
                  //      //console.log(value.length);
                  //    //console.log(!specialCharExpressionForAddr(5, 30).test(value));
                  handleChangeAddress("addressLine3", value);
                }}
                onBlur={() => {}}
                onMouseOut={(val) => {
                  handleChangeAddressErrors("addressLine3", val);
                }}
                placeholder={"House/flat no., Road"}
                errorText={errors.addressLine3}
                helpTextColor="blue"
                helpText={
                  props.addressObj &&
                  props.addressObj.addressLine3 &&
                  props.addressObj.addressLine3.length === addressType[props.addessType-1].size
                    ? "You can enter maximum of "+ addressType[props.addessType-1].size +" characters in this line."
                    : ""
                }
              />
            </div>
          </div>
          {
          props.addessType === 2 && (
            <div className=" form-field custom-col">
              <label className="input-label">Address Line 4</label>
              <div className="italic-placeholder">
                <InputField
                  defaultValue={props.addressObj?.addressLine4}
                  maxLength={addressType[props.addessType-1].size}
                  type="text"
                  onChange={(value) => {
                    handleChangeAddress("addressLine4", value);
                  }}
                  onBlur={() => {}}
                  onMouseOut={(val) => {
                    handleChangeAddressErrors("addressLine4", val);
                  }}
                  placeholder="Locality, Landmark"
                  errorText={errors.addressLine4}
                  helpTextColor="blue"
                  helpText={
                    props.addressObj &&
                    props.addressObj.addressLine4 &&
                    props.addressObj.addressLine4.length === addressType[props.addessType-1].size
                      ? "You can enter maximum of "+ addressType[props.addessType-1].size +" characters in this line."
                      : ""
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div className="custom--row incomeMsg--row">
          <div className=" form-field custom-col">
            <label className="input-label">Pincode</label>
            <div className="italic-placeholder">
              <InputField
                integer={true}
                maxLength={6}
                defaultValue={props.addressObj?.pincode}
                onChange={(value) => {
                  handleChangeAddress("pincode", value);
                }}
                onBlur={() => {}}
                onMouseOut={(val) => {
                  handleChangeAddressErrors("pincode", val);
                }}
                placeholder="Enter Pincode"
                errorText={errors.pincode}
              />
            </div>
          </div>
          <div className=" form-field custom-col">
            <label className="input-label">Area</label>
            <TocDropdown
              selectedValue={
                props.addressObj?.area ? props.addressObj?.area : ""
              }
              dropdownOptions={areaOptions ? areaOptions : []}
              onSelect={(value) => {
                handleChangeAddress("area", value);
              }}
              disabled={pincodeEnabled || areaOptions.length < 1}
              isSearchable={false}
            />
          </div>
        </div>
        <div className="custom--row incomeMsg--row">
          <div className=" form-field custom-col">
            <label className="input-label">State</label>
            <div className="italic-placeholder">
              <InputField
                type="text"
                defaultValue={props.addressObj?.stateStr}
                onChange={(value) => {}}
                onBlur={() => {}}
                placeholder="Enter State"
                disabled={true}
              />
            </div>
          </div>
        </div>
        {!props.childSr && (
          <div className="custom-row permantAddress--row">
            <label className="incomeMsg bold-text">
              {props.textHeadName} Address Proof
            </label>
            <p className="ei-text">Scanned Copy Of Address Proof</p>
            <div className="form-field custom-col-1">
              <TocDropdown
                selectedValue={
                  props.addressObj?.proof
                    ? props.addressObj?.proof
                    : addressProofOptions[0].value
                }
                dropdownOptions={addressProofOptions ? addressProofOptions : []}
                onSelect={(value) => {
                  handleChangeAddress("proof", value);
                }}
                isSearchable={false}
              />
            </div>
            <FileUploadSection
              disableCross={false}
              fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
              onSubmit={handleSubmitForPermantAddressFile}
              fileName={props.addressObj.fileName}
              secondFileName={
                frontBack && backDocument && backDocument.fileName
                  ? backDocument.fileName
                  : ""
              }
              fileSize={1048576}//1MB size
              dropValChanged={dropDownlownValue}
            />
            {frontBack && (
              <FileUploadSection
                disableCross={false}
                fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                onSubmit={handleSubmitForBackDocument}
                secondFileName={
                  frontBack && props.addressObj.fileName
                    ? props.addressObj.fileName
                    : ""
                }
                fileSize={1048576}//1MB size
                dropValChanged={dropDownlownValue}
              />
            )}
            <div>
              <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
                If you want to update address as per aadhar, please process from
                digilocker
              </p>
              {frontBack ? (
                <div>
                  {!props.childSr &&
                    !(
                      props.addressObj &&
                      props.addressObj.fileName &&
                      backDocument &&
                      backDocument.fileName
                    ) && (
                      <>
                        <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
                          Kindly upload clear coloured images of original
                          documents of proof of Address
                        </p>
                      </>
                    )}
                </div>
              ) : (
                <div>
                  {!props.childSr &&
                    !(props.addressObj && props.addressObj.fileName) && (
                      <>
                        <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
                          Kindly upload clear coloured images of original
                          documents of proof of Address
                        </p>
                      </>
                    )}
                </div>
              )}
            </div>
            {!frontBack && (
              <button
                type="button"
                className="ed_button common_button noBg-btn"
              >
                <span className="edel-icon-plus"></span>
                <span
                  onClick={() => {
                    setFrontBack(true);
                  }}
                >
                  Add Front/Back Document
                </span>
              </button>
            )}
            {frontBack && (
              <button
                type="button"
                className="ed_button common_button noBg-btn"
              >
                <span className="edel-icon-minus"></span>
                <span
                  onClick={() => {
                    setFrontBack(false);
                  }}
                >
                  Remove Front/Back Document
                </span>
              </button>
            )}
          </div>
        )}
      </div>
      <EdModal
        show={showPincodeErrorModel}
        close={() => {}}
        children={wrongPinCodeMessagePOPUp()}
        modalClsNm={"absoluteModal"}
      />
    </>
  );
};